import StorefrontApi from 'api/Storefront';
import { SHOP_OPERATIONS, SHOP_QUERIES } from 'constants/storefront';

class StorerontShop {
  static fetchPaymentSettings = async () => {
    const query = SHOP_QUERIES.DIGITAL_WALLETS_QUERY;
    const operationName = SHOP_OPERATIONS.DIGITAL_WALLETS_QUERY;
    const { paymentSettings = {} } = await StorefrontApi.call({ operationName, query });
    return paymentSettings;
  };
}

export default StorerontShop;
